<form (ngSubmit)="onSubmit()" [formGroup]="group">
  <ui-form-select [data]="dataSalutation" [formControlName]="dataSalutation.name"></ui-form-select>
  <ui-form-text [data]="dataFirstName" [formControlName]="dataFirstName.name"></ui-form-text>
  <ui-form-text [data]="dataLastName" [formControlName]="dataLastName.name"></ui-form-text>
  <ui-form-submit [data]="dataSubmit"></ui-form-submit>
</form>
